export default __webpack_public_path__ + "static/media/youtube_link_thumb.c80ffd11.png";